(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-singles/assets/javascripts/route-play-singles.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-singles/assets/javascripts/route-play-singles.js');
"use strict";


const CouponIdProvider = svs.components.tipsen.couponId.CouponIdProvider;
const COUPON_SINGLEROWS = svs.components.tipsen.engine.constants.couponTypes.COUPON_SINGLEROWS;
const Coupon = svs.components.tipsen.coupon.Coupon;
const CouponAdditions = svs.components.tipsen.couponAdditions.CouponAdditions;
const DetailViewRoutePlayHandler = svs.components.tipsen.detailViewRoutePlayHandler.DetailViewRoutePlayHandler;
const CenterToScreen = svs.components.tipsen.centerToScreen.CenterToScreen;
const SingleCouponChoice = svs.components.tipsen.routePlaySingles.SingleCouponChoice;
const BetslipRegistry = svs.components.tipsen.betslipRegistry.BetslipRegistry;
const RenderProvider = svs.component.tipsen.renderContext.RenderProvider;
const pageTypes = svs.component.tipsen.renderContext.constants.pageTypes;
const RoutePlaySingles = () => React.createElement(CouponIdProvider, {
  type: COUPON_SINGLEROWS
}, React.createElement(CenterToScreen, null, React.createElement(RenderProvider, {
  pageType: pageTypes.DEFAULT
}, React.createElement(SingleCouponChoice, null), React.createElement(Coupon, null), React.createElement(CouponAdditions, null)), React.createElement(DetailViewRoutePlayHandler, {
  hasSideNav: false
})), React.createElement(BetslipRegistry, null));
setGlobal('svs.components.tipsen.routePlaySingles.RoutePlaySingles', RoutePlaySingles);

 })(window);